import React from 'react'
import { Icon } from '@scentregroup/ui'
import SwiperCore, { Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { AngleBackground } from '../angle-background'
import { FeaturedLink } from '../../../types/featured-link'
import { Link as LinkType } from '../../../types/link'

import 'swiper/swiper.min.css'

import { Slide } from './slide'

import style from './index.scss'

export const FeaturedLinksHero: React.FC<{
  Link: LinkType
  featuredLinks: Array<FeaturedLink>
}> = ({ Link, featuredLinks }) => {
  // TODO: add google analytics actions to swiper
  // Using:
  // onSlideChange={() => console.log('slide change')}
  // onSwiper={(swiper) => console.log(swiper)}

  SwiperCore.use([Autoplay, Navigation])

  const prevRef = React.useRef<HTMLButtonElement>(null)
  const nextRef = React.useRef<HTMLButtonElement>(null)

  return (
    <div className={style.FeaturedLinksHero}>
      <AngleBackground className={style.background} />
      <div className={style.container}>
        <Swiper
          loop
          autoplay={{ delay: 5000 }}
          spaceBetween={0}
          slidesPerView={1}
          navigation={{
            prevEl: prevRef.current ? prevRef.current : undefined,
            nextEl: nextRef.current ? nextRef.current : undefined,
          }}
          onInit={swiper => {
            const n = swiper.params.navigation as any
            n.prevEl = prevRef.current
            n.nextEl = nextRef.current
            swiper.navigation.update()
          }}
        >
          {featuredLinks.map(featuredLink => (
            <SwiperSlide key={`${featuredLink.title}-${featuredLink.url}`}>
              <Slide featuredLink={featuredLink} Link={Link} />
            </SwiperSlide>
          ))}
          <button ref={prevRef} className={style.prev}>
            <Icon type="arrow-left" />
          </button>
          <button ref={nextRef} className={style.next}>
            <Icon type="arrow-right" />
          </button>
        </Swiper>
      </div>
    </div>
  )
}
